import styled from 'styled-components';
import { toRem, theme } from '../../styles';

export const StyledWelcomeDetail = styled.div`
  h1 {
    font: normal normal var(--t-title-m-font-weight) ${toRem(60)} / normal var(--t-title-font-family);
    text-transform: none;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(30)} / normal var(--t-title-font-family);
    }
    b {
      font-weight: var(--t-title-m-font-weight) !important;
      @media ${theme.mediaQuery.allMobiles} {
        display: block;
        font-weight: var(--t-title-m-font-weight) !important;
      }
    }
  }

  p,
  div {
    &.t-font-m {
      p {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(18)} var(--t-base-font-family) !important;
        @media ${theme.mediaQuery.allMobiles} {
          font: normal normal var(--t-title-m-font-weight) ${toRem(12)} / ${toRem(16)} var(--t-base-font-family) !important;
        }

        &:nth-child(1) {
          font: normal normal var(--t-title-m-font-weight) ${toRem(16)} / ${toRem(24)} var(--t-base-font-family) !important;
          @media ${theme.mediaQuery.allMobiles} {
            font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family) !important;
            b {
              @media ${theme.mediaQuery.allMobiles} {
                display: block;
              }
            }
          }
        }
        &:nth-child(2) {
          b {
            @media ${theme.mediaQuery.allMobiles} {
              display: inline;
            }
          }
        }
      }
    }

    &.t-font-s {
      @media ${theme.mediaQuery.allMobiles} {
        font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family);
        line-height: 20px;
      }
    }
  }

  .content-sec {
    @media ${theme.mediaQuery.allMobiles} {
      margin-bottom: 34px !important;
    }
  }

  .begin-button {
    font: normal normal 700 ${toRem(14)} / ${toRem(17)} var(--t-base-font-family) !important;
    margin: 0 auto !important;
    max-width: 130px;
    width: 100%;
    padding: 11px 11px 12px 11px !important;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal 700 ${toRem(13)} / ${toRem(16)} var(--t-base-font-family) !important;
      max-width: 274px;
      height: auto;
      padding: 8px 16px !important;
    }
  }
  #welcome-modal {
    max-width: 980px;
  }
  #welcome-modal > .container {
    padding: 0px;
    @media ${theme.mediaQuery.largeDesktop} {
      max-width: 840px;
    }
    .welcome-page-wrapper {
      padding: 28px 0px 48px;
      @media ${theme.mediaQuery.allMobiles} {
        padding: 28px 16px 68px;
      }
      @media ${theme.mediaQuery.mediumTablet} {
        padding: 28px 20px 68px;
      }
    }
  }
  .top-right-content {
    justify-content: end;
    @media ${theme.mediaQuery.allMobiles} {
      flex-direction: column;
      align-items: end;
    }
  }
  .top-right-content p {
    margin-bottom: 27px !important;
    @media ${theme.mediaQuery.allMobiles} {
      font: normal normal var(--t-title-m-font-weight) ${toRem(14)} / ${toRem(20)} var(--t-base-font-family) !important;
      margin-bottom: 0px !important;
    }
  }
`;
